import { useMutation } from '@apollo/client';

import { CURRENT_EVENT } from '../../event/graphql/query/currentEventQuery.graphql';
import { STAFF_LEAVE_BEDROOM } from '../graphql/mutation/staffLeaveBedroomMutation.graphql';
import { EVENT_BEDROOMS } from '../graphql/query/eventBedroomsQuery.graphql';

export const useStaffLeaveBedroomMutation = () => {
  const [mutate] = useMutation(STAFF_LEAVE_BEDROOM);

  const staffLeaveBedroom = (
    bedroomId: string,
    eventId: string,
    userId: string,
  ) => {
    mutate({
      variables: {
        bedroomId,
        eventId,
        userId,
      },
      refetchQueries: [EVENT_BEDROOMS, CURRENT_EVENT],
    });
  };

  return { staffLeaveBedroom };
};
